import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

interface ExistingMapping {
  dbField: string;       // Campo fijo de la BD (no se puede cambiar)
  excelField: string;    // Valor detectado del Excel, editable
}

interface NewMapping {
  excelField: string;    // Campo del Excel que no coincide con ningún campo oficial
  newFieldName: string;  // Nombre que se asignará para crear la columna
}

@Component({
  selector: 'app-modal-import-data',
  templateUrl: './modal-import-data.component.html',
  styleUrls: ['./modal-import-data.component.css']
})
export class ModalImportDataComponent implements OnInit {
  fieldMappingsExisting: ExistingMapping[] = [];
  fieldMappingsNew: NewMapping[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any, // data: { headers: string[], headersOficial: string[], totalRows: number }
    private dialogRef: MatDialogRef<ModalImportDataComponent>
  ) {}

  ngOnInit(): void {
    // Inicializamos la sección de campos existentes:
    this.fieldMappingsExisting = this.data.headersOficial.map((dbField: string) => {
      // Buscamos una coincidencia en los encabezados del Excel (ignorando mayúsculas)
      const matchingExcelField = this.data.headers.find((excelField: string) =>
        excelField.toLowerCase() === dbField.toLowerCase()
      );
      return {
        dbField: dbField,
        // Si no se encuentra, usamos el nombre oficial para que no quede vacío
        excelField: matchingExcelField ? matchingExcelField : dbField
      };
    });

    // Inicializamos la sección de campos nuevos
    this.updateNewFields();
  }

  // Este método recalcula los campos nuevos, excluyendo aquellos ya asignados en los existentes
  updateNewFields(): void {
    // Tomamos los valores (en minúsculas) que ya están asignados en la sección de existentes
    const existingValues = this.fieldMappingsExisting.map(mapping => mapping.excelField.toLowerCase());
    // De los encabezados del Excel, filtramos aquellos que NO están en la lista de existentes
    this.fieldMappingsNew = this.data.headers
      .filter((excelField: string) => !existingValues.includes(excelField.toLowerCase()))
      .map((excelField: string) => {
        return {
          excelField: excelField,
          newFieldName: excelField // Por defecto se propone el mismo valor
        };
      });
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  importData(): void {
    // Se envía el mapeo completo, tanto de los campos existentes como de los nuevos
    this.dialogRef.close({
      imported: true,
      fieldMappings: {
        existing: this.fieldMappingsExisting,
        new: this.fieldMappingsNew
      }
    });
  }
}
